import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const Checkbox = ({
  checked,
  children,
  label,
  name,
  onChange,
  value,
}) => {
  const id = uuidv4();
  return (
    <div className="hst-filter__subset">
      <label htmlFor={id}>
        <input
          checked={checked}
          id={id}
          name={name}
          onChange={() => onChange(value)}
          type="checkbox"
          value={value}
        />
        <span>{label}</span>
      </label>
      {children}
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default Checkbox;
